// Funkelstück motion layer — applies scroll-reveal classes to specific
// homepage/product sections (matched by section id suffix, no shared section files touched).
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var singleReveal = ['rich_text_WyQgGK', 'text_and_image_founder', 'featured_product_bestseller', 'text_and_image_ey7cRT', 'product-recommendations'];
  var groupReveal = {
    text_with_icons_trust: '.text-with-icons__block',
    featured_collections_rkEG9M: '.grid__item',
  };

  var targets = [];

  singleReveal.forEach(function (key) {
    var section = document.querySelector('[id$="__' + key + '"]');
    if (section) {
      section.classList.add('fk-reveal');
      targets.push(section);
    }
  });

  Object.keys(groupReveal).forEach(function (key) {
    var section = document.querySelector('[id$="__' + key + '"]');
    if (!section) return;
    var group = section.querySelector(groupReveal[key]) ? section.querySelector(groupReveal[key]).parentElement : null;
    if (group) {
      group.classList.add('fk-reveal-group');
      targets.push(group);
    }
  });

  if (!targets.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fk-in-view');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  targets.forEach(function (el) {
    io.observe(el);
  });
})();
